import React from 'react';
import PropTypes from 'prop-types';
import 'components/styles/delink-delete-success-message.css';
import { ReactComponent as CloseIcon } from 'assets/images/close-icon.svg';
import { ReactComponent as TickMark } from 'assets/images/tick-mark.svg';

const DelinkDeleteSuccessMessage = ({
  deleteMessage,
  setShowDelinkSuccessMessage,
  setShowDeleteSuccessMessage
}) => {
  const handleDelinkSuccessClose = () => {
    setShowDelinkSuccessMessage(false);
  };
  const handleDeleteSuccessClose = () => {
    setShowDeleteSuccessMessage(false);
  };

  return (
    <div className="delink-delete-success-container">
      <div className="delink-delete-content">
        <div className="tick">
          <TickMark/>
        </div>
        <div className="delink-delete-message">
          {deleteMessage
            ? 'You have successfully deleted an employee’s Loyalty account'
            : 'You have successfully de-linked an employee’s Loyalty account'}
        </div>
      </div>
      <div className="delink-delete-actions">
        <div
          className="delink-delete-close"
          onClick={deleteMessage ? handleDeleteSuccessClose : handleDelinkSuccessClose}>
          Close
        </div>
        <div
          className="delink-delete-close-icon"
          onClick={deleteMessage ? handleDeleteSuccessClose : handleDelinkSuccessClose}>
          <CloseIcon/>
        </div>
      </div>
    </div>
  );
};

DelinkDeleteSuccessMessage.propTypes = {
  deleteMessage: PropTypes.bool,
  setShowDelinkSuccessMessage: PropTypes.func,
  setShowDeleteSuccessMessage: PropTypes.func
};

export default DelinkDeleteSuccessMessage;
